export default import.meta.ROLLDOWN_FILE_URL_h380YYj727PmRFA3S5$RuQ